import { AppDocumentos } from '../../../core/models/appDocumentos.model';
import { AppDocumentosService } from '../../../core/services/appDocumentos.service';
import { AppA3DocService } from '../../../core/services/appA3Doc.service';

import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, OnInit, Output, Input, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { MatDialog } from '@angular/material/dialog';
import { UsersDocsDialogComponent } from '../../users-docs-dialog/users-docs-dialog.component';
import { Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DxDataGridComponent } from 'devextreme-angular';
import { AppUsuarioService } from '../../../core/services/appUsuarioService.service';

@Component({
  selector: 'app-empleados-documentos-list',
  templateUrl: './empleados-documentos-list.component.html',
  styleUrls: ['./empleados-documentos-list.component.scss'],
  providers: [AppDocumentosService, AppA3DocService, AppUsuarioService]
})
export class EmpleadosDocumentosListComponent extends ListFormBase<AppDocumentos> implements AfterViewInit {

  @Input() user: any;
  @Input() companyNif: string;
  docsRead: {};
  docsSelected: String[];
  dataAllDocs: String[];
  loadingA3Doc: boolean = false;

  @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;


  constructor(
    protected _modelService: AppDocumentosService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    private appA3DocService: AppA3DocService,
    private appUsuarioService: AppUsuarioService,
    protected _docsUsersPopUp: MatDialog,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(_modelService, _router, _route, _messageDialog, AppDocumentos);
    this.isCrud = false;
    this.docsSelected = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['docsRead']) {
      this.refreshData();
    }
  }

  refreshData() {
    if (this.dataGrid && this.dataGrid.instance) {
      // this.dataGrid.instance.beginCustomLoading('');
      this.loadingA3Doc = true;

      this.appA3DocService.getReadDocsByUser({ user: this.user.user1 })
        .then(result => {
          this.docsRead = result
          this.appA3DocService.getDocumentsWithoutPayrollForEmployee(0, this.companyNif, this.user.nif, this.docsRead, false)
            .then((result) => {
              this.dataSource = result.employeeDocs;
              this.dataAllDocs = result.allDocs;
            })
            .catch((error) => {
              console.error('Error al obtener los documentos:', error);
            })
            .finally(() => {
              // this.dataGrid.instance.endCustomLoading();
              this.loadingA3Doc = false;
            });
        })
        .catch(error => {
          console.error('Error al obtener documentos leidos', error);
        })
    } else {
      console.error('DataGrid no está inicializado correctamente.');
    }
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.refreshData()
    });

  }


  getUrlId(): string {
    var url = this._router.url.split('/');
    return url[url.length - 1]
  }

  getFormattedDate(data: any): string {
    const date = new Date(data.createdAt);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11 en JavaScript
    const year = date.getFullYear();

    // Obteniendo horas y minutos
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Retornando la fecha formateada con hora y minutos
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  onFileOpen(fileData: any) {
    const byteCharacters = atob(fileData);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  onCellPrepared(e) {

    if (e.rowType === 'data' && e.column.dataField === 'name') {

      const linkElement = document.createElement('a');

      // Utiliza una función de flecha para definir el evento clic
      linkElement.onclick = () => {
        this.onFileOpen(e.data.docData);

        // Evita que el enlace realice una redirección
        return false;
      };

      // Establecer el texto del enlace
      linkElement.textContent = e.data.name;
      linkElement.style.textDecoration = 'underline';
      linkElement.style.cursor = 'pointer';

      // Limpiar el contenido existente de la celda y agregar el enlace
      e.cellElement.innerHTML = '';
      e.cellElement.appendChild(linkElement);
    }
  }

  onToolbarPreparing(e) {

    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'addNew'
    });


    const toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(element => {
      if (element.name === 'addRowButton') {
        // Importante, hay que hacer un bind para indicarlo cual es el "this" que debe usar.
        element.options.onClick = this.openNew();
      }
    });
  }

  openNew() {
    const dialogRef = this._docsUsersPopUp.open(UsersDocsDialogComponent, {
      width: '98%',
      data: { company: this.companyNif, data: this.dataAllDocs, dataSelected: this.dataSource },
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#e8e8e8');
    }

    dialogRef.afterClosed().subscribe(result => {

      if (!result) {
        this.loadingA3Doc = false;
        return;
      }

      this.loadingA3Doc = true;

      const updatePromises = result.map(document => {
        // Llamar a updateDocUsers para cada documento
        return this.appA3DocService.updateDocUsers(document, [this.user], false, false)
          .then(response => {
            if (response.response.errorCode === 0) {
              return { failed: false, documentName: document.title };
            } else {
              return { failed: true, documentName: document.title };
            }
          })
          .catch(error => {
            console.error('Error al actualizar el documento:', document.title, error);
            return { failed: true, documentName: document.title };
          });
      });

      // Ejecutar todas las promesas y procesar el resultado al final
      Promise.all(updatePromises)
        .then(results => {
          const failedDocuments = results.filter(result => result.failed).map(result => result.documentName);

          if (failedDocuments.length > 0) {
            this._messageDialog.ShowAlert(
              `Los siguientes documentos no pudieron ser asignados a los empleados: ${failedDocuments.join(', ')}`,
              'Error al asignar documentos'
            );
          } else {
            this._messageDialog.ShowContinueMessage(
              'Todos los documentos fueron asignados a los empleados correctamente',
              'Asignación exitosa'
            ).then(() => { this.refreshData() })
          }
        })
        .catch(error => {
          console.error('Error al procesar las actualizaciones de documentos:', error);
        })
        .finally(() => {
          this.loadingA3Doc = false;
        });
    });
  }


  onDeleteRelation(data: any) {

    this._messageDialog.ShowQuestion(

      `Se desvinculará el documento ${data.title} del empleado`,
      'Desvincular documento del empleado'
    )
      .then(result => {
        if (result.value) {
          this.loadingA3Doc = true;
          this.appUsuarioService.getAllForSelectByCompanyNif(this.companyNif).subscribe(
            (response) => {


              const matchingAttributes = data.attributes.filter(attr => attr.id === '802');

              const valuesToCompare = matchingAttributes.map(attr => attr.value);

              const usersInDocument = response.filter(result => valuesToCompare.includes(result.nif));

              this.appA3DocService.deleteDocUsers(data, this.user, usersInDocument, false)
                .then(response => {
                  this.loadingA3Doc = false;
                  if (response.response.errorCode === 0) {
                    this._messageDialog.ShowContinueMessage(
                      'El documento se ha desvinculado correctamente',
                      'Desvinculación exitosa'
                    ).then(() => { this.refreshData() })
                  } else {
                    this._messageDialog.ShowAlert(
                      'El documento no se pudo denvincular',
                      'Desvinculación fallida'
                    )
                  }
                })
                .catch(error => {
                  this._messageDialog.ShowAlert(
                    'El documento no se pudo denvincular',
                    'Desvinculación fallida')
                  console.error('Error al desvincular el documento:', document.title, error);
                  return { failed: true, documentName: document.title };
                });

            },
            (error) => {
              // Manejar el error
              console.error('Error al obtener los datos:', error);
            }
          );
          /*
          const sendData = {
            doc1: data.doc1,
            user1: this.subjectID
          }
 
            this.userDocsService.deleteDocUserRelation(sendData).subscribe(
 
             response => {
               this.refreshData()
             },
             error => {
               this._messageDialog.ShowAlert(
                 `Error al desvincular ${data.name}`,
                 `Se ha producido un error al desvincular ${data.name}`
               );
               console.error('Error al desvincular:', error);
             }
           ); */
        }
      });
  }



}